import { Box } from '@mui/material'
import AttachmentComposerChip from './AttachmentComposerChip'
import AiAskBarContextPreviews from './AiAskBarContextPreviews'
import styles from './index.module.scss'

export default function AiAskBarAttachmentsSection({
  replyPreview,
  replySnippet,
  onDismissReplyPreview,
  refinementText,
  onDismissRefinement,
  attachments = [],
  imageAttachments = [],
  docAttachments = [],
  onRemoveAttachment,
  openAttachmentGalleryAtId,
}) {
  return (
    <>
      <AiAskBarContextPreviews
        {...{
          replyPreview,
          replySnippet,
          onDismissReplyPreview,
          refinementText,
          onDismissRefinement,
        }}
      />
      {attachments.length > 0 && (
        <Box className={styles.attachmentsWrap}>
          {imageAttachments.length > 0 ? (
            <Box className={styles.attachmentsImagesRow}>
              {imageAttachments.map((item) => (
                <AttachmentComposerChip key={item.id} item={item} onRemove={onRemoveAttachment} onOpenImageGallery={() => openAttachmentGalleryAtId(item.id)} />
              ))}
            </Box>
          ) : null}
          {docAttachments.length > 0 ? (
            <Box className={styles.attachmentsDocsRow}>
              {docAttachments.map((item) => (
                <AttachmentComposerChip key={item.id} item={item} onRemove={onRemoveAttachment} />
              ))}
            </Box>
          ) : null}
        </Box>
      )}
    </>
  )
}
